export const API_BASE_URL = 'https://notsticker-backend-1f08ac3d5994.herokuapp.com';